import { render } from "./SelectActivity.vue?vue&type=template&id=8231156c&scoped=true&lang=true"
import script from "./SelectActivity.vue?vue&type=script&lang=js"
export * from "./SelectActivity.vue?vue&type=script&lang=js"

import "./SelectActivity.vue?vue&type=style&index=0&id=8231156c&lang=css&scoped=true"

import exportComponent from "C:\\laragon\\www\\icl-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8231156c"]])

export default __exports__